import type { BaseCabItemOption } from '@/api';

export const getCabAttributes = (cabOption: BaseCabItemOption) => {
	const { displayPrice, strikePrice = displayPrice } = cabOption.pricing;
	return {
		'Cab Type': cabOption.vehicleType,
		'Fuel Type': cabOption.fuelType,
		Fare: strikePrice,
	};
};

const CAB_IMAGE_MAP: Record<string, string> = {
	SUV: 'https://images.ixigo.com/image/upload/cabAssets/2428db372e5d25a9caa77410c0e428cc-aklme.png',
	HATCHBACK:
		'https://images.ixigo.com/image/upload/cabAssets/11dabbf6f0aa6625a3e2788478254ecb-hcbbs.png',
	MINI: 'https://images.ixigo.com/image/upload/cabAssets/11dabbf6f0aa6625a3e2788478254ecb-hcbbs.png',
	SEDAN:
		'https://images.ixigo.com/image/upload/cabAssets/aed2899ea2195030ccbec670ef3f3c2d-xpsip.png',
};

export const getCabImageUrl = (vehicleType: string) =>
	CAB_IMAGE_MAP[vehicleType.toUpperCase()] || '';
